import { render, staticRenderFns } from "./BusinessSetupComplete.vue?vue&type=template&id=55cd5a90&scoped=true"
import script from "./BusinessSetupComplete.vue?vue&type=script&lang=js"
export * from "./BusinessSetupComplete.vue?vue&type=script&lang=js"
import style0 from "./BusinessSetupComplete.vue?vue&type=style&index=0&id=55cd5a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cd5a90",
  null
  
)

export default component.exports